(function () {
    'use strict';

    angular
        .module('app.performanceReturnOnInvestmentReport')
        .controller('performanceReturnOnInvestmentReportCtrl', ['$location', '$scope', '$rootScope', '$state', 'measureService', 'adminService', '$http', '$controller', 'performanceReturnOnInvestmentReportService', '$modal', 
            function ($location, $scope, $rootScope, $state, measureService, adminService, $http, $controller, performanceReturnOnInvestmentReportService, $modal)
            {
                $scope.currentUser = $rootScope.currentUser;

                $scope.enable = false;
                $scope.currentPage = 1;
                $scope.pageSize = 10;
                $scope.roiReportData = [];
                $scope.getROIReport = function(params)
                {
                    var result = null;
                    params.page_no = $scope.currentPage;
                    params.company_id = $scope.currentPage;

                    if($scope.currentUser.role.accessLevel == 'admin' || $scope.currentUser.role.accessLevel == 'agency') {
                        params.company_id = $rootScope.sideMenuSelections.advertiserId;
                    }
                    
                    if($scope.currentUser.role.accessLevel == 'advertiser') {
                        params.company_id = $scope.currentUser.company.id;
                    }

                    performanceReturnOnInvestmentReportService.getROIReportData(params)
                        .then(function(result){
                            $scope.loadROIReport(result);
                        })
                        .catch(function(message){
                            $scope.roiReportData = [];
                            $scope.roiReportKPI = [];
                        })
                        .finally(function(){
                            $rootScope.$broadcast('sectionLoaded');
                        });
                }

                $scope.loadROIReport = function(result)
                {
                    $scope.roiReportData = result.data;
                    $scope.totalRow = result.totalRow;
                    $scope.loadKPIs(result.KPIs);
                    $scope.pagination();
                }

                $scope.loadKPIs = function(result)
                {
                    result[0].value = result[0].value;
                    result[1].value = result[1].value;
                    result[2].value = result[2].value;
                    result[4].value = result[4].value;
                    $scope.roiReportKPI = result;
                    switch(result[5].value) {
                        case 0:
                            $scope.totalRoiCurrencySymbol = "";
                            break;
                        case 1:
                            $scope.totalRoiCurrencySymbol = "$";
                            break;
                        case 2:
                            $scope.totalRoiCurrencySymbol = "DKK";
                            break;
                        case 3:
                            $scope.totalRoiCurrencySymbol = "NOK";
                             break;
                        case 4:
                            $scope.totalRoiCurrencySymbol = "SEK";
                            break;
                        default:
                    }
                }

                //Watch on change keyword / blog / project change
                $scope.$on('refreshDashboard', function(event, args)
                {
                    getDataROIReport();
                });

                function getDataROIReport()
                {
                    var params = $rootScope.saveParams;
                    if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0))
                    {
                        return;
                    }
                    params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

                    if(params.mention != 0 || params.project_id != 0) {
                        $scope.enable = true;
                    } else {
                        $scope.enable = false;
                    }

                    $scope.getROIReport(params);
                }

                $scope.pagination = function()
                {
                    $scope.pages = adminService.pagination($scope.totalRow, $scope.pageSize);
                }

                $scope.updatePage = function(val)
                {
                    $scope.currentPage = val;
                    getDataROIReport();
                }

                // first initiating
                getDataROIReport();


                $scope.showSettingROIReport = function()
                {
                    var roiSettingModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/measure/performanceReport/performanceReturnOnInvestmentReport/ReturnOnInvestmentSetting/ReturnOnInvestmentSetting.html?app_v=deployDate',
                        controller: 'ReturnOnInvestmentSettingCtrl',
                    });
                    roiSettingModalInstance.result.then(function() {
                        getDataROIReport();
                    });

                    $scope.roiSettingModalInstance = roiSettingModalInstance;
                }

                $scope.influencerOverviewPage = function(influencer_id)
                {
                    $rootScope.previousPage = $location.absUrl();
                    $state.transitionTo('home.influencerOverview',
                        {
                            influencer_id: influencer_id
                        },
                        {
                            reload: false,
                            inherit: true,
                            notify: true
                        }
                    );
                }

            }
        ]);
})();